import React, { Component } from 'react';
import classNames from 'classnames';
import { Layout } from '@nackle/origami';
import { languageChangeEvent, LocaleString } from '@nackle/intl-tools';
import { FetchPrivacyPolicy } from '../fetch-privacy-policy.js';

import './footer.less';
const { Footer } = Layout;

export default class DeckFooter extends Component {
    state = {
        isLoaded: false
    };

    componentDidMount() {
        languageChangeEvent.on( ( { localeCode, bundle } ) => {
            this.setState( {
                isLoaded: true,
                locale: localeCode
            } );
        } );
    }

    render() {
        const { isLoaded, locale } = this.state;
        const { companyId, solutionId } = this.props;
        const classes = classNames( 'nkl-deck-footer', this.props.className );
        const privacyNoticeUrl = locale && FetchPrivacyPolicy( companyId, solutionId, locale );

        return (
            <Footer className={ classes }>
                <div className={ `nkl-deck-footer-loader${ isLoaded ? '' : ' nkl-deck-footer-loading' }` }>
                    <div className="nkl-deck-footer-spinner-container">
                        <Spinner className="nkl-deck-footer-spinner"/>
                    </div>
                </div>
                <div className={ `nkl-deck-footer-links-container${ isLoaded ? '' : ' nkl-deck-footer-loading' }` }>
                    { companyId && solutionId &&
                        <ul className="nkl-deck-footer-links">
                            <li><a href={ privacyNoticeUrl } target="_blank" rel="noreferrer">
                                { <LocaleString code="deck.link.privacyNotice" /> }
                            </a></li>
                        </ul>
                    }
                    <p className="nkl-deck-footer-copyright">
                        <LocaleString
                            code="deck.content.copyright"
                            replaceOptions={ {
                                year: new Date().getFullYear()
                            } }/>
                    </p>
                </div>
            </Footer>
        );
    }
}

export const Spinner = ( { className, ...props } ) => (
    <svg className={ className } viewBox="0 0 24 24">
        <path d="M12 22C17.5228 22 22 17.5228 22 12L19 12C19 15.866 15.866 19 12 19L12 22Z"/>
        <path d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z"/>
    </svg>
);
